import { render, staticRenderFns } from "./FinanceCategory.vue?vue&type=template&id=2266af5a&scoped=true"
import script from "./FinanceCategory.vue?vue&type=script&lang=js"
export * from "./FinanceCategory.vue?vue&type=script&lang=js"
import style0 from "./FinanceCategory.vue?vue&type=style&index=0&id=2266af5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2266af5a",
  null
  
)

export default component.exports